/* Caipi Redesign — Category / PLP interactions: Sort-Dropdown + „Mehr anzeigen" inline.
   Filtering is server-side (Shopify facets via links); quick-add via Canopy's <product-form>. */
(function () {
  'use strict';

  function initSort() {
    document.querySelectorAll('[data-rd-sort]').forEach(function (sel) {
      if (sel.dataset.rdBound === '1') return;
      sel.dataset.rdBound = '1';
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
    });
  }

  /* „Mehr anzeigen": nächste Produktseite per fetch holen und die Karten INLINE ans Grid
     hängen — kein Reload, kein Sprung. Button bleibt ein echter ?page=N-Link (No-JS-Fallback). */
  function initLoadMore() {
    document.querySelectorAll('[data-rd-plp-more]').forEach(function (btn) {
      if (btn.dataset.rdBound === '1') return;
      btn.dataset.rdBound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.getAttribute('aria-busy') === 'true') return;
        var url = btn.getAttribute('href');
        var grid = document.querySelector('.rd-plp__main .rd-grid') || document.querySelector('.rd-grid');
        if (!url || !grid) return;
        var label = btn.textContent;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = 'Lädt …';
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) throw new Error('fetch');
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var ng = doc.querySelector('.rd-plp__main .rd-grid') || doc.querySelector('.rd-grid');
            if (ng) { while (ng.firstElementChild) { grid.appendChild(ng.firstElementChild); } }
            var next = doc.querySelector('[data-rd-plp-more]');
            if (next && next.getAttribute('href')) {
              btn.setAttribute('href', next.getAttribute('href'));
              btn.textContent = label;
              btn.removeAttribute('aria-busy');
            } else if (btn.parentNode) {
              btn.parentNode.removeChild(btn); // letzte Seite erreicht
            }
          })
          .catch(function () { btn.textContent = label; btn.removeAttribute('aria-busy'); });
      });
    });
  }

  function init() { initSort(); initLoadMore(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
